<template src="./index.html"></template>

<script>
import {getdata} from "./data.js";
export default {
  name: "uploadresults",
  data: function () {
    return {
      searchdiag: false,
      shaidiag: false,
      headData: getdata().headData,
      outlist: [],
      searchlist: getdata().searchlist,
      searchdata: getdata().searchdata,
      tableData: [],
      pagination: getdata().pagination,
      tablekey: 0,
    };
  },
  methods: {
    closeshaidiag() {
      this.shaidiag = false;
    },
    confirmfilter(e) {
      this.headData = e.chooselist;
      this.outlist = e.nochooselist;
      this.shaidiag = false;
    },
    closeSearch() {
      this.searchdiag = false;
    },
    saveChange(e) {
      this.searchdiag = false;
    },
    forUpdateSearch() {
      this.searchdiag = true;
    },
    submitSearch() {
      // this.pagination.pageNum = 1
      // this.pagination.paginationkey++
      // this.uploadhistorypage()
    },
    exportExcel() {},
    forRefresh() {},
    fordelete() {},
    sizechange(e) {
      // this.pagination.pageSize = e
      // this.uploadhistorypage()
    },
    currentChange(e) {
      // this.pagination.pageNum = e
      // this.uploadhistorypage()
    },
  },
  mounted() {},
  created() {},
};
</script>

<style scoped lang="less">
@import url("./index.less");
</style>
